<div class="wrap">
    <h2>Infos sur le container</h2>

    <app-container-progress></app-container-progress>
</div>